import { Moment } from 'moment';

import {
  PackageDetailPckInfoViewModel,
  ProviderType,
  RoomVariationViewModel,
} from '@api/v3';
import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import { getCurrencySymbol } from '@utils/utils';
import { checkLoyaltyPreviouslyValidated } from '@components/ui/loyalty-verifications/helpers';
import { SelectedVariationProps } from '@components/views/hotel/detail/context/types';

type RoomParams = {
  selectedVariations: SelectedVariationProps[];
  information: PackageDetailPckInfoViewModel;
  variation: RoomVariationViewModel;
  hotelRoomList: ListingSearchRoomInterface[];
  startDate: Moment;
  endDate: Moment;
  hotelId: number;
  hotelName: string;
  isExpedia: boolean;
  selectedTab: number;
};

// ===================================
// Get Room Card Params
// ===================================
export const getRoomCardProps = ({
  information,
  selectedVariations,
  variation,
  hotelId,
  hotelName,
  hotelRoomList,
  startDate,
  endDate,
  isExpedia,
  selectedTab,
}: RoomParams) => {
  return {
    //roomSquareMeter: detail.roomInfo?.roomSquareMeters,
    childWithPriceCount: information.childWithPriceCount,
    id: hotelId,
    key: variation.id,
    hotelName: hotelName,
    formCheckInDate: startDate,
    formCheckOutDate: endDate,
    hotelRoomList: hotelRoomList,
    title: information.boardTypeName,
    promotionInfoName: variation.promotionInfoName,
    prices: {
      originalPrice: isExpedia
        ? variation.originalTotalDiscountedSellingPrice
        : variation.totalSellingPrice,
      price: variation.totalDiscountedSellingPrice,
      currency: getCurrencySymbol(variation.currency),
      discount: variation.discountRatioText,
      originalCurrency: isExpedia
        ? getCurrencySymbol(variation.originalCurrency)
        : getCurrencySymbol(variation.currency),
    },
    loyaltyDiscount: variation?.seturLoyaltyInfo?.rate,
    loyaltyEarn: variation?.seturLoyaltyInfo?.earn,
    isExpedia: isExpedia,
    hasCancelletion: information.isRefundable,
    roomInformation: `${
      information.adultCount ? information.adultCount + ' Yetişkin ' : ''
    } ${
      information.childWithDiscountedPriceCount &&
      information.childWithDiscountedPriceCount > 0
        ? `${information?.childWithDiscountedPriceCount} İndirimli Çocuk`
        : ''
    } ${
      information.childWithoutPriceCount &&
      information.childWithoutPriceCount > 0
        ? `${information?.childWithoutPriceCount} Ücretsiz Çocuk`
        : ''
    } ${
      information.childWithoutPriceCount === 0 &&
      information.childWithDiscountedPriceCount === 0 &&
      information.childCount
        ? `${information?.childCount} Çocuk`
        : ''
    }`,
    status: information.availabilityStatus,
    isSelected:
      selectedVariations.findIndex(
        (item) =>
          item.variationId === variation.id && item.tabNumber === selectedTab
      ) !== -1,
    loyalty: variation.loyaltyType
      ? {
          isActive:
            variation.isLoyaltyActivated ||
            checkLoyaltyPreviouslyValidated(variation?.loyaltyType),
          loyaltyType: variation.loyaltyType,
        }
      : undefined,

    alertMessage: information.availabilityParameters[0],
    cancellationPolicyDetails: information.cancellationPolicyDetail,
    // nonRefundableDates: detail.roomInfo?.nonRefundableDates,
    // feeDetails: detail.roomInfo?.expediaPriceDetail,
  };
};

// ===================================
// Get Handle Selected Variation Params
// ===================================
export const getHandleSelectedVariationParams = ({
  information,
  variation,
  selectedTab,
  roomId: id,
  roomProvider: provider,
  roomName,
}: Pick<RoomParams, 'selectedTab' | 'information' | 'variation'> & {
  roomId: number;
  roomProvider?: ProviderType;
  roomName?: string;
}) => {
  return {
    tabNumber: selectedTab,
    roomId: id,
    variationId: variation.id,
    promotionInfoName: variation.promotionInfoName,
    totalDiscountedSellingPrice: variation.totalDiscountedSellingPrice || 0,
    cancelletionPolicyId: 0, //It sets to 0 because BE not sending this after they send we will put the value here.
    boardTypeId: information.boardTypeId || 0,
    provider: provider,
    promotionId: variation.promotionIdList || '',
    loyaltyType: variation?.loyaltyType || null,
    guests: {
      adultCount: information.adultCount,
      childrenBirthDates: information.childrenBirthDates,
    },
    //roomTypeId: detail.roomInfo?.roomTypeId,
    boardTypeName: information.boardTypeName,
    roomName: roomName,
  };
};
